import { Directive, Input, TemplateRef, ViewContainerRef, Injector } from '@angular/core';
import { AuthorizeService } from './authorize.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *userAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *userAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
@Directive({
    selector: '[userType]'
})
export class UserTypeDirective {
    constructor(
        private authorizeService: AuthorizeService,
        private injector: Injector,
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef) {
            // this.authorizeService = this.injector.get(AuthorizeService);
    }

    @Input()
    set userType(isMain: boolean) {
        // this.authority = authority;
        this.updateView(isMain);
    }

    private updateView(userType): void {
        let user = this.authorizeService.getUserIdentity();
        this.viewContainerRef.clear();
        if (user && user.userType === userType) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
